/**
 * Default tracing options
 */
export default {
  enabled: false,
  endpoint: 'api.rollbar.com/api/1/session/',
};
